import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Text,
} from "@chakra-ui/react";

import { LuPlus, LuTrash2 } from "react-icons/lu";

import type { Participant } from "@features/services/travel/types";

const ParticipantRow = ({
  index,
  participant,
  onNameChange,
  onDelete,
  canDelete,
}: {
  index: number;
  participant: Participant;
  onNameChange: (id: string, name: string) => void;
  onDelete: (id: string) => void;
  canDelete: boolean;
}) => (
  <Flex
    align="center"
    gap={4}
    px={4}
    py={2}
    borderWidth="1px"
    borderColor="border.dark"
    borderRadius="md"
    bg="surface.background"
  >
    <Text fontSize="sm" color="text.secondary" minW={6} fontWeight="medium">
      {index + 1}.
    </Text>
    <Input
      flex={1}
      placeholder="Type participant's name"
      value={participant.name}
      onChange={(e) => onNameChange(participant.id, e.target.value)}
      variant="flushed"
      px={0}
      borderColor="transparent"
      _focus={{ borderColor: "transparent" }}
    />
    {canDelete && (
      <Button
        variant="ghost"
        size="sm"
        aria-label="Remove participant"
        onClick={() => onDelete(participant.id)}
      >
        <Box as={LuTrash2} boxSize={4} color="red.300" />
      </Button>
    )}
  </Flex>
);

const ParticipantsStep = ({
  participants,
  onAddParticipant,
  onUpdateParticipant,
  onDeleteParticipant,
}: {
  participants: Participant[];
  onAddParticipant: () => void;
  onUpdateParticipant: (id: string, name: string) => void;
  onDeleteParticipant: (id: string) => void;
}) => (
  <Flex flexDirection="column" gap={6} mt={8}>
    <Flex flexDirection="column" gap={1}>
      <Heading size="lg" color="fg">
        Participants
      </Heading>
      <Text color="text.secondary" fontSize="sm">
        Add participants for your travel. The first row is pre-filled from your
        details.
      </Text>
    </Flex>
    <Flex flexDirection="column" gap={2} maxW={{ base: "full", md: "lg" }}>
      {participants.map((p, i) => (
        <ParticipantRow
          key={p.id}
          index={i}
          participant={p}
          onNameChange={onUpdateParticipant}
          onDelete={onDeleteParticipant}
          canDelete={participants.length > 1}
        />
      ))}
      <Button
        variant="outline"
        size="sm"
        alignSelf="flex-start"
        mt={1}
        borderColor="border.dark"
        onClick={onAddParticipant}
      >
        <Flex as="span" align="center" gap={2}>
          <LuPlus /> Add participant
        </Flex>
      </Button>
    </Flex>
  </Flex>
);

export default ParticipantsStep;
